import { Fade } from "@material-ui/core";
import React, { useState } from "react";
import {

  PortalContext,
  PortalSplash
} from '@portal/arq-portal-core';
import { findQueryKeyNoCaseSensitive } from "./helpers";

export type Chatbotv2Props = { url: string, titulo:string, user: string};

export const Chatbotv2 = (props: Chatbotv2Props) => {
  let { user } = React.useContext(PortalContext);
  const [isLoaded, setIsLoaded] = useState(false);
  var queryUser = findQueryKeyNoCaseSensitive('user');
  var queryTitulo = findQueryKeyNoCaseSensitive('titulo');
  var queryUrl = findQueryKeyNoCaseSensitive('url');
  var titulo = queryTitulo?? props.titulo ?? "Chatbot Incidencias"
  var url = queryUrl?? props.url ?? "https://app-an-lab-dev.azurewebsites.net/"
  var userId = queryUser ?? props.user ?? user?.id
  url = url + "?user=" + userId;


  return (
    <div>
      {!isLoaded && <PortalSplash titulo={titulo}></PortalSplash>}
      {
        <Fade in={isLoaded} timeout={1000}>
          <iframe
            name="<__MAINFRAME__>"
            className="site-layout-content-iframe"
            allow="camera;microphone;clipboard-write"
            sandbox="allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock allow-popups-to-escape-sandbox allow-modals allow-downloads"
            seamless
            src={ url?? undefined}
            title={titulo}
            style={{
              width: "1px",
              minWidth: "100%",
              border: "0px",
              display: isLoaded ? "block" : "none",
              minHeight: "calc(100vh - 52px)",
              backgroundColor: "#ffffff"
            }}
            onLoad={() => {
              setIsLoaded(true);
            }}
          />
        </Fade>}
    </div>
  );
}
